export default __webpack_public_path__ + "static/media/box 2 light.65f30275.svg";